// packages imports
import { Controller, useFormContext } from 'react-hook-form'
import { FormControl, FormHelperText, InputLabel, MenuItem, Select, SxProps } from '@mui/material'

// others
import { anchorOrigin, transformOrigin } from '../../../../theme/styleConstants'
import { BillingCycle } from '../../../../../generated'
import { useEffect } from 'react'
import { Billing_Cycle_Options } from '../../../../constants'

interface BillingCyclesListProps {
  name: string
  title: string
  sx?: SxProps
}

const BillingCyclesList = ({ name, title, sx }: BillingCyclesListProps) => {
  const { control, watch, setValue } = useFormContext()
  const billingCycle = watch(name)
  const customDay = watch('billing.billingCycleCustomDate')

  useEffect(() => {
    if (billingCycle === BillingCycle.CustomDate) {
      const customDay = watch('billing.billingCycleCustomDate')
      setValue('billing.billingCycleCustomDate', customDay || 1)
    } else {
      setValue('billing.billingCycleCustomDate', null)
    }
  }, [billingCycle, setValue, watch])

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error: { message } = {}, invalid } }) => (
          <FormControl variant="outlined" fullWidth error={invalid} sx={sx}>
            <InputLabel id="role-select">{title}</InputLabel>
            <Select
              {...field}
              labelId="role-select"
              label={title}
              fullWidth
              MenuProps={{ anchorOrigin: anchorOrigin, transformOrigin: transformOrigin }}
            >
              {Billing_Cycle_Options.map((item, index) => {
                return (
                  <MenuItem value={item.value} key={`${item.value}-${index}`}>
                    {item.label}
                  </MenuItem>
                )
              })}
            </Select>

            {invalid && message && (
              <FormHelperText sx={{ color: theme => theme.palette.error.main }}>{message}</FormHelperText>
            )}
          </FormControl>
        )}
      />

      {billingCycle === BillingCycle.CustomDate && (
        <Controller
          name="billing.billingCycleCustomDate"
          control={control}
          render={({ field, fieldState: { error: { message } = {}, invalid } }) => {
            return (
              <FormControl error={!!invalid}>
                <InputLabel>Day of Month</InputLabel>
                <Select
                  {...field}
                  label="Day of Month"
                  value={field.value || ''}
                  onChange={e => field.onChange(e.target.value)}
                >
                  {Array.from({ length: 31 }, (_, i) => i + 1).map(day => (
                    <MenuItem key={day} value={day}>
                      {day}
                    </MenuItem>
                  ))}
                </Select>
                {!!invalid && message && <FormHelperText>{message}</FormHelperText>}
                {customDay && customDay > 28 && (
                  <FormHelperText>In some months, this date may be adjusted to the last available day</FormHelperText>
                )}
              </FormControl>
            )
          }}
        />
      )}
    </>
  )
}

export default BillingCyclesList
